module.exports = __webpack_public_path__ + "img/Logistics-Courierstation.8bd480bc.jpg";